export default __webpack_public_path__ + "static/media/quienes.4000b564.png";